import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { applyBrand } from "@/lib/tenant";

export default function TraegerStammdatenTab() {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/traeger-center/stammdaten").then((r) => setF(r.data)); }, []);
  if (!f) return <div className="text-xs text-slate-400">Lädt…</div>;
  const set = (k, v) => setF({ ...f, [k]: v });
  const nums = f.weitere_nummern || [];
  const save = async () => {
    try {
      const { bundeslaender, ...body } = f; // eslint-disable-line no-unused-vars
      const { data } = await api.put("/traeger-center/stammdaten", body);
      setF(data);
      applyBrand(data.brand_color);
      toast.success("Stammdaten gespeichert");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };
  return (
    <div className="border border-slate-200 bg-white p-5 space-y-4 max-w-3xl" data-testid="traeger-stammdaten">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <label className="text-xs text-slate-600 flex flex-col">Rechtsform<input value={f.rechtsform || ""} onChange={(e) => set("rechtsform", e.target.value)} placeholder="z. B. UG (haftungsbeschränkt)" className="input-tech mt-1" data-testid="stamm-rechtsform" /></label>
        <label className="text-xs text-slate-600 flex flex-col">Trägernummer<input value={f.traeger_nummer || ""} onChange={(e) => set("traeger_nummer", e.target.value)} className="input-tech mt-1" data-testid="stamm-traegernummer" /></label>
        <label className="text-xs text-slate-600 flex flex-col">Bundesland (für Feiertage)
          <select value={f.bundesland} onChange={(e) => set("bundesland", e.target.value)} className="input-tech mt-1" data-testid="stamm-bundesland">
            {Object.entries(f.bundeslaender).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
        </label>
        <label className="text-xs text-slate-600 flex flex-col">DATEV-Upload-Adresse (Ausgangsrechnungen)<input value={f.datev_email || ""} onChange={(e) => set("datev_email", e.target.value)} placeholder="…@uploadmail.datev.de" className="input-tech mt-1" data-testid="stamm-datev-email" /></label>
        <label className="text-xs text-slate-600 flex flex-col">Dashboard-Farbe
          <span className="flex items-center gap-2 mt-1">
            <input type="color" value={f.brand_color || "#0a788c"} onChange={(e) => set("brand_color", e.target.value)} className="h-9 w-12 border border-slate-200" data-testid="stamm-brand-color" />
            <input value={f.brand_color || ""} onChange={(e) => set("brand_color", e.target.value)} placeholder="#0a788c" className="input-tech flex-1 font-mono" data-testid="stamm-brand-color-hex" />
          </span>
        </label>
      </div>
      <div>
        <div className="text-xs text-slate-600 mb-1">Weitere Nummern</div>
        <div className="space-y-2">
          {nums.map((n, i) => (
            <div key={i} className="flex gap-2" data-testid={`stamm-num-${i}`}>
              <input value={n.label} onChange={(e) => set("weitere_nummern", nums.map((x, j) => (j === i ? { ...x, label: e.target.value } : x)))} placeholder="Bezeichnung, z. B. USt-IdNr." className="input-tech flex-1" data-testid={`stamm-num-label-${i}`} />
              <input value={n.value} onChange={(e) => set("weitere_nummern", nums.map((x, j) => (j === i ? { ...x, value: e.target.value } : x)))} placeholder="Nummer" className="input-tech flex-1" data-testid={`stamm-num-value-${i}`} />
              <button onClick={() => set("weitere_nummern", nums.filter((_, j) => j !== i))} className="text-slate-400 hover:text-red-600" data-testid={`stamm-num-del-${i}`}><Trash2 size={14} /></button>
            </div>
          ))}
          <button onClick={() => set("weitere_nummern", [...nums, { label: "", value: "" }])} className="text-xs text-slate-600 hover:text-slate-900 flex items-center gap-1" data-testid="stamm-num-add"><Plus size={12} /> Nummer hinzufügen</button>
        </div>
      </div>
      <label className="text-xs text-slate-600 flex flex-col">Allgemeine Informationen<textarea rows={3} value={f.allgemeine_info || ""} onChange={(e) => set("allgemeine_info", e.target.value)} className="input-tech mt-1 resize-none" data-testid="stamm-info" /></label>
      <button onClick={save} className="px-5 py-2.5 bg-slate-900 text-white text-sm hover:bg-black" data-testid="stamm-save">Speichern</button>
    </div>
  );
}
